import { fromJS } from 'immutable';

import { updateUserDetailsType } from './UserDetailsConstants';
import { logoutType } from '@Constants/User';


export const initialState = fromJS({
});


export default function userDatabasesReducer (state = initialState, action) {
  switch(action.type) {

    case updateUserDetailsType: {
      const { details } = action.payload;

      if(!details) {
        return initialState;
      }

      return fromJS(details);
    }

    case logoutType: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
